// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"537":"4f38d0f4c66b4898","671":"12764b7d25aed9b6"}[chunkId] + ".js";
};